module.exports = __webpack_public_path__ + "static/media/mid-taste.04e3099e.png";